import React from "react"

export const FooterComponent  = () => {
  return (
  <>
    <tmo-digital-footer></tmo-digital-footer>
  </>
  )
}
